export const realtorData = {
  email: 'jorgebarra@unne.cl',
  phone:"973780112"
  // email: 'contacto@accionpanal.com',
};
